// extracted by mini-css-extract-plugin
module.exports = {"landing":"CX-6E-0RQTMGW9t4wh2KpQ==","wrapper":"_9YP8Y4m39RGbbBGn4Wfnww=="};